// The browser half: takes over the page the server drew (hydration), so it
// works before any of this loads and only gains behaviour once it does.
import { createRoot, hydrateRoot } from 'react-dom/client';
import App from './App.jsx';
import './site.css';

const boot = window.__KG_SITE__;
const root = document.getElementById('root');
if (boot && root) {
  if (boot.csr) {
    // The server could not draw this page: fetch its data and draw it here.
    fetch(`/api/site-data?path=${encodeURIComponent(boot.path)}&search=${encodeURIComponent(window.location.search)}`, { credentials: 'same-origin' })
      .then((r) => (r.ok ? r.json() : Promise.reject(new Error('data'))))
      .then((out) => createRoot(root).render(<App boot={{ ...boot, route: out.status === 404 ? 'not-found' : boot.route, data: out.data }} />))
      .catch(() => { root.innerHTML = '<p style="padding:24px">This page could not be loaded. Please refresh.</p>'; });
  } else if (root.hasChildNodes()) hydrateRoot(root, <App boot={boot} />);
  else createRoot(root).render(<App boot={boot} />);
}

// Installable site + its app shell (same service worker as before).
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((r) => r.update().catch(() => {})).catch(() => {});
  });
}
